// @ts-nocheck
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface SetUpdateModalIsOpenParameter {
    isOpen: boolean;
}

type HandlerType = Handler<SetUpdateModalIsOpenParameter>;

export const DispatchSetUpdateModalIsOpen: HandlerType = props => {
    props.dispatch({
        type: "Data/BackOrders/SetUpdateModalIsOpen",
        parameter: props.parameter,
    });
};

export const chain = [DispatchSetUpdateModalIsOpen];

const setUpdateModalIsOpen = createHandlerChainRunner(chain, "SetUpdateModalIsOpen");
export default setUpdateModalIsOpen;
